import { ActivitiesSummarizedByStudent } from 'presentation/app/modules/Reports/pages/activities/summarized/activities-summarized-by-student';

export const MakeActivitiesSummarizedByStudent: React.FC = () => {
  return <ActivitiesSummarizedByStudent />;
};
